export default function toRem(value, baseFontSize = 16) {
    if (value === undefined || value === 0) {
        return value;
    }
    else {
        return `${value / baseFontSize}rem`;
    }
}
